import { FC, ReactNode } from 'react';

import { Step, StepLabel, Stepper, Tooltip } from '@mui/material';
import { grey, red } from '@mui/material/colors';
import { Box, SxProps } from '@mui/system';

import CustomStepConnector from './components/CustomStepConnector';

type StepperStep = {
  label: string;
  icon?: ReactNode;
  hasError?: boolean;
};

type WaveUIStepperProps = {
  steps: StepperStep[];
  activeStep: number;
  sx?: SxProps;
};

const WaveUIStepper: FC<WaveUIStepperProps> = ({ steps, activeStep, sx }) => {
  return (
    <Stepper
      activeStep={activeStep}
      sx={sx}
      connector={<CustomStepConnector />}
    >
      {steps.map((step, index) => (
        <Step key={step.label}>
          <Tooltip title={step.label} placement='top' arrow>
            <StepLabel
              StepIconComponent={() => {
                return (
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      width: 50,
                      height: 50,
                      borderRadius: '50%',
                      backgroundColor: grey[100],
                      color: grey[400],
                      border: '2px solid',
                      borderColor: grey[100],

                      ...(index <= activeStep && {
                        backgroundColor: grey[100],
                        borderColor: grey[400],
                        color: 'primary.main',
                      }),

                      ...(step.hasError && {
                        borderColor: red[400],
                        backgroundColor: red[50],
                        color: 'error.main',
                      }),
                    }}
                  >
                    {step.icon}
                  </Box>
                );
              }}
            ></StepLabel>
          </Tooltip>
        </Step>
      ))}
    </Stepper>
  );
};

export default WaveUIStepper;
